import React, { useEffect } from 'react';
import {
  createBrowserRouter,
  RouterProvider,
  createRoutesFromElements,
  Route,
  Navigate,
  Outlet,
  useNavigate,
  useLocation
} from 'react-router-dom';
import { Box } from '@mui/material';
import { AuthProvider, useAuth } from './context/AuthContext';
import Header from './components/Header';
import Footer from './components/Footer';
import Login from './pages/Login';
import RequestsList from './pages/RequestsList';
import CreateRequest from './pages/CreateRequest';
import EditRequest from './pages/EditRequest';
import AcceptRequest from './pages/AcceptRequest';
import Support from './pages/Support';
import PrivacyPolicy from './pages/PrivacyPolicy';
import { setNavigationInstance } from './utils/navigation';

const NavigationSetter = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    setNavigationInstance(navigate);
  }, [navigate]);
  
  return null;
};

const Layout = () => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  const isPublicPage = location.pathname === '/support' || location.pathname === '/privacy-policy';

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
      }}
    >
      <NavigationSetter />
      {(isAuthenticated || isPublicPage) && <Header />}
      <Box component="main" sx={{ flexGrow: 1 }}>
        <Outlet />
      </Box>
      <Footer />
    </Box>
  );
};

const PrivateRoute = () => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <Outlet /> : <Navigate to="/login" />;
};

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<Layout />}>
      <Route path="/login" element={<Login />} />
      <Route path="support" element={<Support />} />
      <Route path="privacy-policy" element={<PrivacyPolicy />} />
      <Route element={<PrivateRoute />}>
        <Route path="/" element={<Navigate to="/requests" />} />
        <Route path="requests">
          <Route index element={<RequestsList />} />
          <Route path="new" element={<CreateRequest />} />
          <Route path=":id/edit" element={<EditRequest />} />
          <Route path=":id/accept" element={<AcceptRequest />} />
        </Route>
      </Route>
    </Route>
  )
);

const App = () => {
  return (
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  );
};

export default App; 